import { render } from "./EmailChangeVerification.vue?vue&type=template&id=a8854790&scoped=true"
import script from "./EmailChangeVerification.vue?vue&type=script&lang=js"
export * from "./EmailChangeVerification.vue?vue&type=script&lang=js"

import "./EmailChangeVerification.vue?vue&type=style&index=0&id=a8854790&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a8854790"]])

export default __exports__